// src/delay.ts
import { setTimeoutEx } from "@xylabs/timer";
var delay = (ms) => {
  return new Promise((resolve) => setTimeoutEx(resolve, ms));
};
export {
  delay
};
//# sourceMappingURL=index.mjs.map